/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import { Box, Button, Modal, TextField, Typography } from '@mui/material';
import { VOUCHER_STATUS } from 'modules/enumerations/enumerationIds';
import { Permissions } from 'modules/layout/permissions';
import { hasPermission } from 'modules/layout/permissionService';

const eq = (a, b) => String(a || '').toLowerCase() === String(b || '').toLowerCase();

const VoucherDetailsButtons = ({
  isFormValidForApproval = false,
  voucherStatusId,
  voucherInfoForm,
  voucherInfo,
  isDirty = false,
  updateVoucher,
  setVoucherInfoForm,
  isAcumaticaRejected,
  pushVoucherToAcumaticaFunc,
  addOpen,
  expandedId,
  isReadOnly,
  canEditPayrollDate,
  isFeeVoucher = false,
  canUpdateVoucher = false
}) => {
  const [open, setOpen] = useState(false);
  const [denyReason, setDenyReason] = useState(voucherInfoForm?.denyReason || '');
  const canSubmit = hasPermission(Permissions.Finance.Vouchers.Submit);
  const canApprove = hasPermission(Permissions.Finance.Vouchers.Approve);
  const canSetPending = isFeeVoucher
    ? hasPermission(Permissions.Finance.Fees.Edit)
    : canSubmit;
  const canSubmitAndApprove = isFeeVoucher
    ? hasPermission(Permissions.Finance.Fees.Approve)
    : canSubmit && canApprove;
  const canApproveAll = isFeeVoucher
    ? hasPermission(Permissions.Finance.Fees.Approve)
    : canApprove;

  const pushStatus = async targetStatusId => {
    const next = {
      ...voucherInfoForm,
      voucherInformation: {
        ...voucherInfoForm?.voucherInformation,
        voucherStatusId: targetStatusId
      },

      denyReason: eq(targetStatusId, VOUCHER_STATUS.DENIED) ? denyReason : undefined
    };
    await updateVoucher(next);
  };

  const DraftView = (
    <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end', width: '100%' }}>
      <Button variant="contained" onClick={() => setVoucherInfoForm(voucherInfo)} disabled={!canEditPayrollDate || !isDirty}>
        Cancel
      </Button>
      <Button variant="contained" onClick={() => updateVoucher(voucherInfoForm)} disabled={!canEditPayrollDate || !isDirty}>
        Save Draft
      </Button>
      <Button variant="contained" onClick={() => pushStatus(VOUCHER_STATUS.PENDING)} disabled={isReadOnly || !canSetPending || !isFormValidForApproval || addOpen || !!expandedId}>
        Set As Pending
      </Button>
      <Button variant="contained" color="primary" onClick={() => pushStatus(VOUCHER_STATUS.APPROVED)} disabled={(!isFeeVoucher && isReadOnly) || !canSubmitAndApprove || !isFormValidForApproval || addOpen || !!expandedId}>
        Submit and Approve
      </Button>
    </Box>
  );

  const PendingView = (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
      <Button variant="contained" onClick={() => setOpen(true)} disabled={isReadOnly}>
        Deny
      </Button>
      <Box sx={{ display: 'flex', gap: 1 }}>
        <Button variant="contained" onClick={() => pushStatus(VOUCHER_STATUS.DRAFT)} disabled={isReadOnly}>
          Reopen to Draft
        </Button>
        <Button variant="contained" onClick={() => setVoucherInfoForm(voucherInfo)} disabled={!canEditPayrollDate || !isDirty}>
          Cancel
        </Button>
        <Button variant="contained" onClick={() => updateVoucher(voucherInfoForm)} disabled={!canEditPayrollDate || !isDirty}>
          Save
        </Button>
        <Button variant="contained" color="primary" onClick={() => pushStatus(VOUCHER_STATUS.APPROVED)} disabled={(!isFeeVoucher && isReadOnly) || !canUpdateVoucher || !canApproveAll || !isFormValidForApproval || addOpen || !!expandedId}>
          Approve All
        </Button>
      </Box>

      <Modal open={open} onClose={() => setOpen(false)}>
        <Box sx={{ width: 500, p: 3, m: 'auto', mt: '20vh', bgcolor: 'white', borderRadius: 2 }}>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Enter Deny Reason
          </Typography>
          <TextField fullWidth multiline rows={4} value={denyReason} onChange={e => setDenyReason(e.target.value)} />
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
            <Button onClick={() => setOpen(false)}>Cancel</Button>
            <Button
              onClick={async () => {
                await pushStatus(VOUCHER_STATUS.DENIED);
                setOpen(false);
              }}
              variant="contained"
              disabled={isReadOnly}
            >
              Save
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );

  const DeniedView = (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        width: '100%',
        gap: 1,
        flexWrap: 'wrap'
      }}
    >
      <Button variant="contained" onClick={() => pushStatus(VOUCHER_STATUS.DRAFT)} disabled={isReadOnly}>
        Reopen to Draft
      </Button>
      <Button variant="contained" onClick={() => pushStatus(VOUCHER_STATUS.PENDING)} disabled={isReadOnly}>
        Set As Pending
      </Button>
    </Box>
  );

  const ApprovedView = (
    <Box sx={{ display: 'flex', justifyContent: 'flex-end', width: '100%', gap: 1 }}>
      {isAcumaticaRejected && (
        <Button variant="contained" onClick={pushVoucherToAcumaticaFunc} disabled={isReadOnly}>
          Push to Acumatica
        </Button>
      )}
      <Button variant="contained" onClick={() => pushStatus(VOUCHER_STATUS.DRAFT)} disabled={isReadOnly}>
        Reopen to Draft
      </Button>
      <Button variant="contained" onClick={() => pushStatus(VOUCHER_STATUS.PENDING)} disabled={isReadOnly}>
        Reopen to Pending
      </Button>
      <Button variant="contained" onClick={() => pushStatus(VOUCHER_STATUS.DENIED)} disabled={isReadOnly}>
        Deny
      </Button>
    </Box>
  );

  const view = eq(voucherStatusId, VOUCHER_STATUS.PENDING)
    ? PendingView
    : eq(voucherStatusId, VOUCHER_STATUS.DENIED)
    ? DeniedView
    : eq(voucherStatusId, VOUCHER_STATUS.APPROVED)
    ? ApprovedView
    : DraftView;

  return <>{view}</>;
};

export default VoucherDetailsButtons;
